import { Layout } from 'antd'
import Sider from './components/Sider'
import Header from './components/Header'
import Content from './components/Content'
import SummaryProvider from './SummaryContext'
import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'

const Summary: React.FC = () => {
  return (
    <PayItemSelectProvider>
      <SummaryProvider>
        <Layout
          style={{
            background: 'unset',
            minHeight: '85vh',
            overflow: 'clip',
            maxHeight: '85vh',
          }}
        >
          <Header />
          <Layout style={{ background: 'unset' }}>
            <Sider />
            <Content />
          </Layout>
        </Layout>
      </SummaryProvider>
    </PayItemSelectProvider>
  )
}

export default Summary
